<template>
  <div>
    <TopNavBar :title="getNickName(item)"></TopNavBar>
    <div class="moment-detail-page" v-if="item && item.id">
      <div>
        <MomentDetail :item="item"></MomentDetail>
        <CommentInfo :itemId="itemId"></CommentInfo>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast, Pagination, Button, Icon} from "vant"
  import MomentDetail from "./MomentDetail";
  import CommentInfo from "../../comment/CommentInfo";
  import TopNavBar from "../../common/TopNavbar"

  export default {
    name: "MomentDetailPage",
    components: {
      Icon,
      CommentInfo,
      MomentDetail,
      Pagination,
      Button,
      TopNavBar,
    },

    data() {
      return {
        itemId: 0,

        isLoading: true,
        item: {},

        commentAction: "",
        commentActionIdx: 0,
        commentActionItemId: 0,
        commentActionReplyUserName: "",
        commentActionTargetCommentId: 0,

        totalCount: 0,
        currentPage: 1,
        countPerPage: 0,
        isLoadingMomentList: true,
        itemList: [],
      }
    },

    async mounted() {
      this.itemId = parseInt(this.$route.params.id)
      this.commentActionItemId = this.itemId

      await this.initMomentData()
    },

    methods: {
      getNickName(item) {
        if (!item || !item.user) {
          return ""
        }
        return item.user.nickname
      },
      async initMomentData() {
        this.isLoading = true
        this.item = {}
        let q = this.$route.query

        let queries = {}
        for (let i in q) {
          queries[i] = q[i]
        }
        queries.id = this.itemId
        await this.$store.dispatch("GetUgcItem", queries).then((data) => {
              if (data.code !== 0) {
                Toast.fail("内容不存在")
              } else {
                this.item = data.data;
              }
            }, () => {
              Toast.fail("网络错误")
            }
        );
        this.isLoading = false
      },

      onClickReply(replyCommentParams) {
        this.commentAction = "reply"
        this.commentActionReplyUserName = replyCommentParams.replyUserName
        this.commentActionTargetCommentId = replyCommentParams.replyCommentId
        this.commentActionItemId = replyCommentParams.replyItemId
        this.commentActionIdx += 1
      },

      onClickDigg(diggCommentParams) {
        this.commentAction = "digg"
        this.commentActionTargetCommentId = diggCommentParams.commentId
        this.commentActionIdx += 1
      },
      goBack() {
        if (!goBackNative()) {
          this.$router.go(-1)
        }
      }
    },
    computed: {
      showPostBtn() {
        if (this.item && this.item.is_author) {
          return true
        }
        return false
      },
    }
  }
</script>

<style lang="scss" scoped>

  .top-fix {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 10;
  }

  .top-info {
    min-height: 15px;
    padding: 15px 15px;
    font-size: 14px;
    background: white;
    border-bottom: 1px solid #f2f2f2;
    position: relative;
    align-items: center;
    display: flex;
    justify-content: center;

    .back-btn-inline {
      position: absolute;
      left: 15px;
      top: 15px;
    }

    .back-title-inline {
      max-width: 50%;
      overflow: hidden;
      -ms-text-overflow: ellipsis;
      text-overflow: ellipsis;
      white-space: nowrap;

    }
  }

  .moment-detail-page {
    padding-bottom: 45px;
    min-height: 100vh;
  }

  .comment-data {
    border-top: 1px solid #f2f2f2;
    background: rgba(246, 246, 246, 0.89);
  }

  .bottom-fix-bar {
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 100;
    width: 100%;
    background: white;
    padding: 5px 0;
    border-top: 1px solid #f2f2f2;

    .post-moment-btn-container {
      text-align: center;
      width: 30%;
      padding: 0 8px;

      .post-btn {
        width: 100%;
      }
    }

    .comment-action-container {
      flex: 1 1 auto;
    }
  }

</style>
